import {
  COMPARISON_OPERATORS,
  FILTER_TYPES,
} from '@witmetrics/utils/constants';
import { API } from '@/api';
import { searchProjects } from '@/utils/options';

export const classes = {
  paper: 'fixed top-8 rounded-2xl',
  wrapper: 'flex flex-col w-[90vw] max-w-[800px] min-w-[200px] min-h-0',
  inputBase: 'w-full text-2xl px-6 py-4 flex-0',
  recentlyViewedWrapper: 'place-between px-6 py-0',
  recentlyViewed: 'text-base text-grey-8 dark:text-mauve-1 font-medium',
  clearButton:
    'text-grey-7 dark:text-mauve-2 hover:text-grey-8 dark:hover:text-mauve-1',
  resultsList: 'flex-0 max-h-[40vh] overflow-auto',
  recentList: 'pt-0 mt-0',
};

export async function fetchMatchingProjects(query: string) {
  return searchProjects(query, [
    'name',
    'description',
    'user.firstname',
    'user.lastname',
    'user.externalRef',
  ]);
}

export async function fetchRecentProjects(projectIds: number[]) {
  const { results } = await API.UnisonProjects.fetchUnisonProjects({
    pagination: { page: 1, pageSize: 5 },
    filters: [
      {
        filterType: FILTER_TYPES.COLUMN_VALUE,
        column: 'id',
        comparisonOperator: COMPARISON_OPERATORS.IN.value,
        value: projectIds,
      },
    ],
  });
  if (!results) return [];
  // Match the original projectIds order
  return results.sort(
    (a, b) => projectIds.indexOf(a.id) - projectIds.indexOf(b.id)
  );
}
